/**
 *  © 2015 -2022 HCL Technologies Limited, all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

import React, { useState, useRef } from 'react';
import { COLLECTION } from '../../../constants/endpoints';
import api from '../../../utils/muApi';
import Loader from '../../Common/Loader';
import { withTranslation } from 'react-i18next';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import Slider from 'react-slick';
import Modal, { useModal } from '../../Common/Modal';
import { checkDevice, createDestinationUrl, validateCbr } from '../../../utils/utils';
import CollectionExplore from './CollectionExplore';
import MU from '../../../constants/muConstants';
import * as track from '../../../utils/analytics';
import Transform from '../../../data-transform';
import { Collection } from '../../../data-transform/components/Collection';
import { COLLECTION_MODAL } from '../../../constants/containerConstants';
import ErrorBoundary from '../../Common/ErrorBoundary';
import {
  beforeCardRenderAccessbility,
  afterChangeAccessbility,
  afterCardRenderAccessibility,
  onLoadAccessibility,
  CollectionDialog,
} from './CollectionAccessbility';
import Article from './Cards/Article';
import Image from './Cards/Image';
import Quote from './Cards/Quote';
import Social from './Cards/Social';
import PlayerProfile from './Cards/PlayerProfile';
import Video from './Cards/Video';
import { playOnNextPre, pauseOnNextPrev } from '../../../utils/brightcove';
import Poll from './Cards/Poll';
import ContentAccessModal from '../../Common/ContentAccessModal';
import CollectionAccessModal from './CollectionAccessModal';
import { useSponsorValue } from '../../../context/sponsorContext';

let slick = {};
const CollectionModal = (props) => {
  const {
    t,
    itemid,
    closeModal,
    cardData,
    isDestinationPage,
    onClose,
    sitecoreContext,
    isMediaPlaying,
  } = props;
  const { showModal, closeModal: cbrCloseModal, isModalVisible } = useModal();
  const layoutId = sitecoreContext && sitecoreContext.route && sitecoreContext.route.layoutId;
  const isTouchDevice = checkDevice();
  const slickRef = useRef(null);
  const cbrRef = useRef(null);
  let itemViewed = '';
  let nextSlide, prevSlide;
  let nextPrevType;
  let prevIndex;
  const [collection, setCollection] = useState({ startCollection: false });
  const [cbrState, setcbrState] = useState(null);
  const [{ userLoginDetail, isUserLogin, isUserSubscribe }] = useSponsorValue();
  const [state, setState] = useState({
    status: 'fetching',
    noCardsFound: false,
    error: null,
    data: null,
  });

  const fetchImageGallery = () => {
    const route = `${COLLECTION}${encodeURI(itemid && itemid.toUpperCase())}`;
    return api
      .get({ route })
      .then((data) => {
        let docs =
          data &&
          data.data &&
          data.data.CollectionResponse &&
          data.data.CollectionResponse.response &&
          data.data.CollectionResponse.response.docs;
        docs = docs.length
          ? [
              ...docs,
              {
                contenttype_t: 'lastcard',
              },
            ]
          : docs;
        setState(() => ({
          ...state,
          status: 'success',
          data: supportedCardFilter(docs),
          noCardsFound: docs.length,
        }));
      })
      .catch((err) => {
        setState(() => ({
          ...state,
          status: 'error',
          error: err,
        }));
      });
  };
  const trackCollectionExit = (data, e) => {
    const initialData = track.data('collectionExit');
    track.analytics(
      {
        ...initialData,
        author: cardData.AuthorName && cardData.AuthorName.value,
        card_name: cardData.ShortHeadline && cardData.ShortHeadline.value,
        collectionDestUrl:
          cardData.manutds && cardData.manutds.value && cardData.manutds.value.DestinationUrl,
        collectionTitle: cardData.ShortHeadline && cardData.ShortHeadline.value,
        container_type: COLLECTION_MODAL,
        content_exit: itemViewed,
        content_items: state.data && state.data.length,
        content_items_viewed: itemViewed,
        content_type: 'collection',
        created_datetime: cardData.__Published && cardData.__Published.value,
        destination_url:
          cardData.manutds && cardData.manutds.value && cardData.manutds.value.DestinationUrl,
        item_id: itemid,
        tag: cardData.manutds && cardData.manutds.value && cardData.manutds.value.Tags,
      },
      e
    );
  };
  const trackCard = (index) => {
    let card = state.data[index];
    var type = card && card.contenttype_t && card.contenttype_t.toLowerCase();
    if (type === 'image' || type === 'quote') {
      const initialData = track.data('card');
      track.analytics({
        ...initialData,
        author: card.authorname_s,
        card_name: card.shortheadline_t,
        container_type: COLLECTION_MODAL,
        content_type: card.contenttype_t,
        created_datetime: card.appearance_tdt || card.__published_tdt,
        destination_url: card.destinationurl_s,
        item_id: card.itemid_s,
        tag: card.taglist_sm,
      });
    }
  };
  const PrevArrow = (props) => {
    const { className, style, onClick, currentSlide } = props;
    itemViewed = currentSlide + 1;
    return (
      <React.Fragment>
        {!isTouchDevice && (
          <button
            type="button"
            data-role="none"
            className={`${className} slider-prev`}
            aria-label={t('Previous')}
            tabIndex="0"
            onClick={(e) => {
              onClick && onClick();
              arrowEvents(slick, e, 'click');
            }}
            onKeyPress={(e) => {
              arrowEvents(slick, e, 'keyPress');
            }}
            onKeyUp={(e) => {
              arrowEvents(slick, e, 'keyUp');
            }}
            aria-disabled={currentSlide === 0}
            style={{
              ...style,
              display: 'block',
              background: 'none',
              border: 'none',
            }}
          >
            <i className="icon-prev"></i>
          </button>
        )}
      </React.Fragment>
    );
  };
  const NextArrow = (props) => {
    const { className, style, onClick, currentSlide, slideCount } = props;
    itemViewed = currentSlide + 1;
    return (
      <React.Fragment>
        {!isTouchDevice && (
          <button
            type="button"
            data-role="none"
            className={`${className} slider-next`}
            aria-label={t('Next')}
            tabIndex="0"
            onClick={(e) => {
              onClick && onClick();
              arrowEvents(slick, e, 'click');
            }}
            onKeyPress={(e) => {
              arrowEvents(slick, e, 'keyPress');
            }}
            onKeyUp={(e) => {
              arrowEvents(slick, e, 'keyUp');
            }}
            aria-disabled={slideCount === currentSlide + 1}
            style={{
              ...style,
              display: 'block',
              background: 'none',
              border: 'none',
            }}
          >
            <i className="icon-next"></i>
          </button>
        )}
      </React.Fragment>
    );
  };
  const arrowEvents = (slick, e, type) => {
    if (type === 'keyPress' || type === 'keyUp' || type === 'touch') {
      let event = e.nativeEvent.which;
      setTimeout(() => {
        nextPrevType = event === 13 ? true : false;
      }, 100);
    } else {
      nextPrevType = e.nativeEvent.which === 13 ? true : false;
    }
    clearSlickClass(slick);
  };
  const supportedCardFilter = (docs) => {
    let newData = [];
    if (docs) {
      docs.map((card, index) => {
        var type = card.contenttype_t && card.contenttype_t.toLowerCase();
        if (
          type === 'article' ||
          type === 'image' ||
          type === 'poll' ||
          type === 'quote' ||
          type === 'social' ||
          type === 'playerprofile' ||
          type === 'adcard' ||
          type === 'video' ||
          type === 'lastcard'
        ) {
          newData.push(card);
        }
        return '';
      });
      return newData;
    } else {
      return docs;
    }
  };
  const loadCard = (card, index) => {
    if (card) {
      var contentType = card.contenttype_t && card.contenttype_t.toLowerCase();
      switch (contentType) {
        case 'article':
          return (
            <Article
              destUrl={
                createDestinationUrl(card.destinationurl_s) + '?request=muapp&collection=true'
              }
              index={index}
              contentType={card.contenttype_t}
              heading={card.shortheadline_t}
              container={COLLECTION_MODAL}
            />
          );
        case 'image':
          return <Image container={COLLECTION_MODAL} data={updateData(card)} index={index} />;
        case 'poll':
          return <Poll container={COLLECTION_MODAL} data={updateData(card)} index={index} />;
        case 'quote':
          return <Quote container={COLLECTION_MODAL} data={updateData(card)} index={index} />;
        case 'social':
          return <Social container={COLLECTION_MODAL} data={updateData(card)} index={index} />;
        case 'playerprofile':
          return (
            <PlayerProfile
              isCollection={true}
              container={COLLECTION_MODAL}
              data={updateData(card)}
              source="aws"
            />
          );
        case 'adcard':
          return (
            <Transform
              gridClass={'grid-12 adcard'}
              isCollection={true}
              data={updateData(card)}
              container={COLLECTION_MODAL}
              source="aws"
            />
          );
        case 'video':
          return (
            <Video
              container={COLLECTION_MODAL}
              data={updateData(card)}
              index={index}
              isMediaPlaying={isMediaPlaying}
              currentActiveSlide={cbrRef.current && cbrRef.current.activeIndex}
              slick={slick && slick.track}
              stopVideo={cbrState && cbrState.index === index}
              onSkip={onSkip}
            />
          );

        default:
          return null;
      }
    }
  };

  const renderCollection = (card, index) => {
    return loadCard(card, index);
  };
  const updateData = (card) => {
    if (card && (card.appearance_tdt || card.__published_tdt)) {
      if (!card.appearance_tdt) {
        card.appearance_tdt = card.__published_tdt;
      }
    }
    return card;
  };
  const hideProgressBar = (slick, newIndex) => {
    let lastSlickDot = state.data.length === newIndex + 1;
    slick.dots && (slick.dots.style.opacity = lastSlickDot ? 0 : null);
    return;
  };
  const pauseVideo = () => {
    const getcurrentVideo = slick.track && slick.track.querySelector('.slick-current');
    if (getcurrentVideo) {
      const currentSlide = getcurrentVideo.querySelectorAll('.mu-item__player').length;
      if (currentSlide) {
        const videoAttr = getcurrentVideo.querySelector('video-js');
        if (videoAttr) {
          const videoAttrId = videoAttr.getAttribute('id');
          pauseOnNextPrev(videoAttrId);
        }
      }
    }
    return;
  };

  const playVideo = () => {
    const getcurrentVideo = slick.track && slick.track.querySelector('.slick-current');
    if (getcurrentVideo) {
      const currentSlide = getcurrentVideo.querySelectorAll('.mu-item__player').length;
      if (currentSlide) {
        const videoAttr = getcurrentVideo.querySelector('video-js');
        if (videoAttr) {
          const videoAttrId = videoAttr.getAttribute('id');
          cbrRef.current && cbrRef.current.playVideo && playOnNextPre(videoAttrId);
        }
      }
    }
    return;
  };

  const isFirstCard = (slick) => {
    // @To show message on mobile device for swipe left or right...
    let swipElm = document.getElementById('Swipemessage');
    if (isTouchDevice && swipElm) {
      let activeDot = slick.dots && slick.dots.querySelectorAll('li');
      activeDot = activeDot && activeDot[0];
      activeDot =
        activeDot && activeDot.className.replace(/[\n\t]/g, ' ').indexOf('slick-active') > -1;
      if (activeDot) {
        swipElm.style.display = 'block';
        let fadeTimer = null;
        clearTimeout(fadeTimer);
        fadeTimer = setTimeout(() => {
          let fadeEffect = setInterval(function () {
            if (!swipElm.style.opacity) {
              swipElm.style.opacity = 1;
            }
            if (swipElm.style.opacity > 0) {
              swipElm.style.opacity -= 0.1;
            } else {
              clearInterval(fadeEffect);
            }
          }, 50);
        }, 3000);
      }
    }
  };
  const setIframeUrl = (activeIframeDom) => {
    if (activeIframeDom) {
      let pageURL = activeIframeDom.getAttribute('data-pageurl');
      pageURL && activeIframeDom.setAttribute('src', pageURL);
      activeIframeDom.onload = function () {
        getIframecontent(activeIframeDom, slick);
        isFirstCard(slick);
      };
    }
  };
  const iframeBeforeChange = (slick) => {
    let slickCurrent = slick.slider && slick.slider.querySelector('.slick-current');
    if (slickCurrent) {
      let iframeLength = slickCurrent.querySelectorAll('.iframedom');
      if (iframeLength) {
        try {
          if (iframeLength.length > 0) {
            let frame = iframeLength[0];
            let frameDoc = frame.contentDocument || frame.contentWindow.document;
            frameDoc.body.scrollTo(0, 0);
            frameDoc.documentElement.innerHTML = '';
          }
        } catch (e) {
          console.info('Issue in collection Iframe', e);
        }
      }
    }
  };
  const addSlickClass = (slick) => {
    if (!isTouchDevice) {
      slick.slider && slick.slider.classList.add('gray-btn');
    }
  };
  const clearSlickClass = () => {
    if (!isTouchDevice) {
      slick.slider && slick.slider.classList.remove('gray-btn');
    }
  };
  const captureSwipeEvents = (el) => {
    if (el) {
      el.addEventListener('touchstart', startTouch, false);
      el.addEventListener('touchmove', moveTouch, false);
      // Swipe Up / Down / Left / Right
      let initialX = null;
      let initialY = null;
      function startTouch(e) {
        initialX = e.touches[0].clientX;
        initialY = e.touches[0].clientY;
      }
      function moveTouch(e) {
        if (initialX === null) {
          return;
        }
        if (initialY === null) {
          return;
        }
        let currentX = e.touches[0].clientX;
        let currentY = e.touches[0].clientY;
        let diffX = initialX - currentX;
        let diffY = initialY - currentY;
        if (Math.abs(diffX) > Math.abs(diffY)) {
          // sliding horizontally
          if (diffX > 0) {
            // swiped left
            slickRef && slickRef.current && slickRef.current.slickNext();
          } else {
            // swiped right
            slickRef && slickRef.current && slickRef.current.slickPrev();
          }
        } else {
          // sliding vertically
          if (diffY > 0) {
            // swiped up
          } else {
            // swiped down
          }
        }
        initialX = null;
        initialY = null;
        e.preventDefault();
      }
    }
  };
  const getIframecontent = (iframebody, slick) => {
    if (iframebody) {
      let iframe = iframebody.contentDocument || iframebody.contentWindow.document;
      let el = iframe && iframe.querySelector('body');
      if (el) {
        let tmplErrorMsg = el.querySelector('.tpl-basic');
        tmplErrorMsg && tmplErrorMsg.classList.add('pageNotFoundonCollection');
        /*Set iframe title for accessablity*/
        let iframeArticleTitle = el.querySelector('.mu-item.xlarge .home-article-detail__title');
        iframeArticleTitle = iframeArticleTitle && iframeArticleTitle.textContent;
        iframeArticleTitle = iframeArticleTitle && iframeArticleTitle.trim();
        if (iframeArticleTitle) {
          iframebody.setAttribute('title', iframeArticleTitle);
        }
        el.addEventListener(
          'gestureend',
          function (e) {
            e.preventDefault();
          },
          false
        );
      }
      if (isTouchDevice) {
        captureSwipeEvents(el);
      }
      /* Added for if portrait came as hero  */
      let firstelm = iframe && iframe.querySelector('.hybrid-article');
      firstelm = firstelm && firstelm.children;
      firstelm = firstelm && firstelm[0];
      if (firstelm) {
        let classname = firstelm.className;
        classname = classname && classname.trim();
        let videoPanel =
          classname.replace(/[\n\t]/g, ' ').indexOf('home-article-detail__video-panel') > -1;
        if (videoPanel) {
          firstelm.classList.add('home-article-detail__top-panel');
          firstelm.style.background = '#000000';
        }
      }
      iframe.addEventListener('scroll', (ev) => {
        let heroHeight;
        let topPanel = iframe && iframe.querySelector('.home-article-detail__top-panel');
        if (isTouchDevice) {
          heroHeight = topPanel && topPanel.offsetHeight - 80;
        } else {
          heroHeight = topPanel && topPanel.offsetHeight - 250;
        }
        let scrollFrame = iframe.documentElement && iframe.documentElement.scrollTop;
        let stickyBg = slick.track && slick.track.querySelector('.slick-active');
        stickyBg = stickyBg && stickyBg.querySelector('.collectionpaging_wrapper');
        if (scrollFrame > heroHeight) {
          stickyBg && stickyBg.classList.add('stickybg');
          addSlickClass(slick);
        } else {
          stickyBg && stickyBg.classList.remove('stickybg');
          clearSlickClass(slick);
        }
      });
      let loader = iframebody.closest('.iframeSwipe');
      loader = loader && loader.querySelector('.iframeloader');
      loader = loader && (loader.style.display = 'none');
      // Accessibility for article Iframe.
      let collectionWrapper = document.getElementById('modal-root');
      collectionWrapper =
        collectionWrapper && collectionWrapper.querySelector('.dialog.collection_modal');
      CollectionDialog(collectionWrapper, 'carousalDialog', slick);
    }
  };
  const isDetailPageActive = (slick, index) => {
    let slickCurrent = slick.track && slick.track.querySelector('.slick-current');
    let activeIframeDom = slickCurrent && slickCurrent.querySelector('.iframedom');
    if (activeIframeDom) {
      let iframeSwipe = activeIframeDom.closest('.iframeSwipe');
      let ifrmaeLoader = iframeSwipe && iframeSwipe.querySelector('.iframeloader');
      ifrmaeLoader && (ifrmaeLoader.style.display = 'block');
      setIframeUrl(activeIframeDom);
    } else if (slickCurrent) {
      isFirstCard(slick);
    }
  };
  const onSlickInit = (slick) => {
    let carousalLoadedInterval = setInterval(function () {
      let currentSlide = slick.track && slick.track.querySelector('.slick-current');
      currentSlide && currentSlide.setAttribute('tabindex', 0);
      let iframedom = currentSlide && currentSlide.querySelector('.iframedom');
      let player = currentSlide && currentSlide.querySelector('.mu-item__player');
      if (iframedom) {
        clearInterval(carousalLoadedInterval);
        setIframeUrl(iframedom);
      } else if (player) {
        clearInterval(carousalLoadedInterval);
        //initVideo(slickActiveElm);
        isFirstCard(slick);
      } else {
        clearInterval(carousalLoadedInterval);
        isFirstCard(slick);
      }
    }, 100);
  };
  let settings = {
    focusOnSelect: true,
    // lazyLoad: 'progressive',
    lazyLoad: 'ondemand',
    touchMove: true,
    draggable: true,
    dots: true,
    infinite: false,
    speed: 200,
    swipe: true,
    fade: true,
    cssEase: 'linear',
    accessibility: false,
    arrows: true,
    rtl: false,
    arabic: MU.language === 'ar' ? true : false,
    asNavFor: null,
    slide: 'span',
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    onInit: () => {
      let slider = document.querySelector('.collectionCards');
      let list = slider && slider.querySelector('.slick-list');
      let slideTrack = list && list.querySelector('.slick-track');
      let slides = slideTrack && slideTrack.querySelectorAll('.slick-slide');
      let dots = slider && slider.querySelector('.slick-dots');
      let nextArrow = slider && slider.querySelector('.slick-next.slider-next.slick-arrow');
      let prevArrow = slider && slider.querySelector('.slick-prev.slider-prev.slick-arrow');
      slick = {
        slider: slider,
        list: list,
        track: slideTrack,
        slides: slides,
        dots: dots,
        nextArrow: nextArrow,
        prevArrow: prevArrow,
      };
      onSlickInit(slick);
      const showCbr = validateAccess(state.data[0]);
      showAccessModal(state.data[0], 0, showCbr);
      showCbr && showCbr.value && onLoadAccessibility(slick, true);
    },
    // onLazyLoad: (slide) => {
    //   if(slide && slide[0] === 0){
    //     setTimeout(()=>{
    //       playVideo();
    //     },1000)
    //   }
    // },
    appendDots: (dots) => {
      if (dots && dots.length) {
        let totalLi = dots.length;
        let percentWidthLi = 100 / totalLi + '%';
        let isActive = true;
        let list = dots.map((val, index) => {
          isActive = isActive ? val.props.className !== 'slick-active' : false;
          return (
            <li
              key={index}
              className={`${val.props.className} ${isActive ? 'active' : ''}`}
              style={{
                width: percentWidthLi,
              }}
            ></li>
          );
        });
        return (
          <ul
            style={{
              display: 'flex',
            }}
            tabIndex="-1"
            aria-hidden="true"
          >
            {list}
          </ul>
        );
      }
    },
    beforeChange: (oldIndex, newIndex) => {
      const showCbr = validateAccess(state.data[newIndex]);
      showAccessModal(state.data[newIndex], newIndex, showCbr);
      prevIndex = oldIndex;
      iframeBeforeChange(slick);
      // Hide slick progressBar for last card
      hideProgressBar(slick, newIndex);
      // next prev handle
      nextSlide = oldIndex < newIndex;
      prevSlide = oldIndex > newIndex;
      // Pause video on next previous
      if (nextSlide !== prevSlide) {
        pauseVideo(oldIndex, newIndex);
      }

      // Accessbility control before change
      beforeCardRenderAccessbility(slick, showCbr && showCbr.value);
      if (nextSlide) {
      }
      if (prevSlide) {
      }
    },
    afterChange: (index) => {
      isDetailPageActive(slick, index);
      // Video handle
      //initVideo($(event.target).find('.slick-current'));
      nextSlide = prevIndex < index;
      prevSlide = prevIndex > index;
      if (nextSlide !== prevSlide) {
        playVideo(prevIndex, index);
      }
      const showCbr = validateAccess(state.data[index]);
      afterChangeAccessbility(slick, nextSlide, prevSlide, nextPrevType, showCbr && showCbr.value);
      afterCardRenderAccessibility(slick, showCbr && showCbr.value);
      if (nextSlide) {
        trackCard(index);
      }
      if (prevSlide) {
        trackCard(index);
      }
    },
  };
  const showCollectionCard = (e) => {
    if (e.type === 'click' || e.which === 13) {
      fetchImageGallery();
      setCollection((collection) => ({
        ...collection,
        startCollection: true,
      }));
      track.pageView(false, layoutId);
    }
  };

  const validateAccess = (data) => {
    return validateCbr({
      isUserLogin,
      contentAccess: data.contentaccess_t,
      contentType: data.contenttype_t,
      manutds: data.taglist_sm,
      isAws: true,
      isUserSubscribe,
    });
  };
  const showAccessModal = (data, index, showCbr) => {
    if (showCbr && showCbr.value) {
      setcbrState({ index: index, value: showCbr.accessCheck, contenttype: data.contenttype_t });
      cbrRef.current = { playVideo: false, activeIndex: index };
      showModal('', true);
    } else {
      cbrRef.current = { playVideo: true, activeIndex: index };
      isModalVisible && cbrCloseModal(true);
    }
  };

  const onSkip = (e) => {
    if (slickRef && slickRef.current) {
      setTimeout(() => {
        slickRef.current.slickNext();
        const initialData = track.data('button');
        track.analytics({ ...initialData, button_name: 'Skip', destination_url: '#' }, e);
        cbrCloseModal(true);
      }, 1000);
    }
  };
  const successCallback = ({ showContent }) => {
    if (showContent) {
      cbrCloseModal(true);
      if (cbrRef.current) {
        cbrRef.current.playVideo = true;
      }
      cbrState.contenttype === 'article' && isDetailPageActive(slick, cbrState.index);
      onLoadAccessibility(slick, false);
      cbrState.contenttype === 'video' && playVideo();
    }
  };
  const onCloseBtn = () => {
    cbrCloseModal(true);
    setTimeout(() => {
      trackCollectionExit();
      isDestinationPage && onClose();
      closeModal();
    }, 100);
  };

  const getAnalyticsData = (cardData) => {
    const initialData = track.data('card');
    return {
      ...initialData,
      card_name: cardData.ShortHeadline && cardData.ShortHeadline.value,
      item_id: itemid,
      content_type: cardData.ContentType && cardData.ContentType.value,
      tag: cardData.manutds && cardData.manutds.value && cardData.manutds.value.Tags,
      created_datetime: cardData.__Published && cardData.__Published.value,
      author: cardData.AuthorName && cardData.AuthorName.value,
      destination_url:
        cardData.manutds && cardData.manutds.value && cardData.manutds.value.DestinationUrl,
      container_type: COLLECTION_MODAL,
    };
  };

  return (
    <Modal
      containerClass="dialog collection_modal"
      showClose={isModalVisible ? false : true}
      closeModal={closeModal}
      ariaDescribedBy="dialog1_label"
      onClose={() => {
        trackCollectionExit();
        onClose && onClose();
      }}
    >
      {isDestinationPage && (
        <ContentAccessModal
          ContentAccess={cardData && cardData.ContentAccess && cardData.ContentAccess.value}
          ContentType={cardData && cardData.ContentType && cardData.ContentType.value}
          manutds={cardData && cardData.manutds}
          className={`collectioncard-modal`}
          insideModal={true}
          isDestinationPage={isDestinationPage}
          analyticsObj={getAnalyticsData(cardData)}
        />
      )}
      <div className="collectioncard-modal">
        <div className="mu-modal__body__container">
          {!collection.startCollection && (
            <CollectionExplore
              data={cardData}
              itemid={itemid}
              showCollectionCard={showCollectionCard}
              isDestinationPage={isDestinationPage}
              layoutId={layoutId}
            />
          )}
          {collection.startCollection && state.status === 'fetching' && (
            <Loader className="collectionitemloader" />
          )}
          {(!state.noCardsFound || state.status === 'error') &&
            collection.startCollection &&
            state.status !== 'fetching' && (
              <div className="noimage" aria-hidden="true">
                {t('Sorrythiscontentisnotavailableat')}
              </div>
            )}
          {!(!state.noCardsFound || state.status === 'error') && collection.startCollection && (
            <div className="collectioncard_items" id="collectioncard_items">
              <div
                className="swipe-message"
                id="Swipemessage"
                style={{
                  display: 'none',
                }}
                aria-hidden="true"
                tabIndex="-1"
              >
                {t('SwipeToGoForwardsAndBack')}
              </div>
              <div className="message"></div>
              <Slider ref={slickRef} {...settings} className="collectionCards">
                {state.data.map((card, index) => {
                  return (
                    <React.Fragment key={index}>
                      <div
                        className="collectionpaging_wrapper"
                        tabIndex="-1"
                        aria-hidden="true"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div
                          tabIndex="-1"
                          aria-hidden="true"
                          className={`collectionpaging ${
                            state.data.length === index + 1 ? 'opacityfalse' : ''
                          }`}
                        >
                          {index + 1}/ {state.data.length}
                        </div>
                      </div>
                      <div className="all-cards__wrapper">
                        <div className="all-cards">
                          {state.data.length === index + 1 ? (
                            <CollectionExplore
                              data={cardData}
                              itemid={itemid}
                              showCollectionCard={showCollectionCard}
                              lastCard={true}
                              closeModal={closeModal}
                              trackCollectionExit={trackCollectionExit}
                              isDestinationPage={isDestinationPage}
                              upsell={cardData && cardData.UpsellMapping}
                            />
                          ) : (
                            <React.Fragment>
                              <div className="collectionSlide_item" id={`collectionSlide${index}`}>
                                {isModalVisible && cbrState && cbrState.index === index && (
                                  <ErrorBoundary>
                                    <CollectionAccessModal
                                      modalId={`collectionSlide${index}`}
                                      closeModal={closeModal}
                                      contentAccess={cbrState.value}
                                      fallback={<Loader />}
                                      data={state.data && state.data[cbrState.index]}
                                      currentIndex={cbrState.index}
                                      totalSlide={state.data && state.data.length}
                                      successCallback={successCallback}
                                      showClose={false}
                                      onSkip={onSkip}
                                      onCloseBtn={onCloseBtn}
                                      analyticsObj={getAnalyticsData(Collection(card, true).fields)}
                                    ></CollectionAccessModal>
                                  </ErrorBoundary>
                                )}
                              </div>
                              <div className="collection-allCard__Wrapper">
                                {renderCollection(card, index)}
                              </div>
                            </React.Fragment>
                          )}
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
              </Slider>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};
export default withSitecoreContext()(withTranslation()(CollectionModal));
